import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Categories from "@/components/site/Categories";
import Featured from "@/components/site/Featured";
import EmailCapture from "@/components/site/EmailCapture";
import About from "@/components/site/About";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";
import PromoBanner from "@/components/site/PromoBanner";
import Testimonials from "@/components/site/Testimonials";
import ActivityTicker from "@/components/site/ActivityTicker";
import Playground from "@/components/site/Playground";
import SEO from "@/components/seo/SEO";

const Landing = () => {
  return (
    <main data-testid="landing-page" className="min-h-screen bg-[#F7F7F4]">
      <SEO path="/" />
      <PromoBanner />
      <Header />
      <Hero />
      <Categories />
      <Featured />
      <ActivityTicker />
      <Playground />
      <Testimonials />
      <EmailCapture />
      <About />
      <FAQ />
      <Footer />
    </main>
  );
};

export default Landing;
